<template>
  <div>
    <v-btn color="primary" dark class="mb-2 rbtn" to="/restaurants/create"
      >{{ $t("restaurantsPage.new") }}</v-btn
    >
    <DataTable
      :url="api.ACTIONS.PASSENGERS"
      :titles="titles"
      :fields-hidden-main="['deleted_at', 'updated_at', 'billing_email', 'address', 'phone_number']"
      :fields-hidden-add="['id', 'deleted_at', 'created_at', 'updated_at', 'address']"
      :input-types-add="{
        password: 'password',
        password_confirmation: 'password',
      }"
      :formatter="formatters"
      :title='$t("restaurantsPage.pageTitle")'
      :enableEdit="false"
      :add-rules="rules"
      :enableAdd="false"
      :initialUrlSearchParams="par"
      :actions-extra-main="actionsExtraMain"
    />
  </div>
</template>
<style>
.rbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}
</style>
<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";

export default {
  name: "Restaurants",
  title: "restaurantsPage.pageTitle",
  components: { DataTable },
  data() {
    return {
      accommodation: "restaurant",
      formatters: {
        created_at(value) {
          return formatCompanyTime(value, " DD MMM YYYY");
        },
      },
    };
  },
  computed: {
    rules() {
      const required = (val) =>
        (val !== null && val !== undefined) ||
        this.$t("restaurantsPage.fieldRequired");
      return {
        username: [required],
        password: [required],
      };
    },
    par() {
      const par = new URLSearchParams();
      par.append("type", this.accommodation);
      return par;
    },

    titles() {
      return {
        id: this.$t("restaurantsPage.colNumber"),
        username: this.$t("restaurantsPage.colUserName"),
        full_name: this.$t("restaurantsPage.colRestaurantName"),
        phone: this.$t("restaurantsPage.colPhoneNumber"),
        created_at: this.$t("restaurantsPage.colCreationDate"),
      };
    },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("restaurantsPage.profile"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "PassengerProfile",
              params: { id: item.id },
            }),
        },
      };
    },
  },
};
</script>
